/**
 * Settings Page
 */

import { Card, CardBody, CardHeader } from '@heroui/react';
import { useUser } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/')({
  component: SettingsPage,
});

function SettingsPage() {
  const { user, isLoaded } = useUser();

  return (
    <div className="container-page max-w-2xl py-4">
      <Card className="border border-default-100 shadow-none">
        <CardHeader className="pb-1 pt-3 px-4">
          <h2 className="text-sm font-medium">Profile</h2>
        </CardHeader>
        <CardBody className="space-y-3 px-4 pb-4 pt-2">
          {isLoaded && user ? (
            <>
              <div className="flex items-center justify-between text-xs">
                <span className="text-default-500">Email</span>
                <span>{user.emailAddresses[0]?.emailAddress}</span>
              </div>
              <div className="flex items-center justify-between text-xs">
                <span className="text-default-500">Name</span>
                <span>{user.fullName || 'Not set'}</span>
              </div>
            </>
          ) : (
            <p className="text-xs text-default-500">Loading...</p>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
